// extracted by mini-css-extract-plugin
export default {"error":"yYXjj7X","label":"DohAXIB","btn":"paEhbEc","actions":"fmHpfQ8","cancelBtn":"DR7Z8r7","applyBtn":"aPgqpjc"};